import React from "react";

export function SettingPage() {
  return <h2>Settings Content</h2>;
}
